
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deklaracja-dostepnosci",
      function () {
        return require("private-next-pages/deklaracja-dostepnosci/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deklaracja-dostepnosci"])
      });
    }
  